/**
 * Toggle Main nav
 *
 * @since 1.0.0
 */

const ToggleMainNav = () => {
  const toggle = document.querySelector('.js-toggle-main-nav')
  if (!toggle) return

  toggle.addEventListener('click', () => {
    document.body.classList.toggle('has-active-main-nav')
  })
}

export default ToggleMainNav



// WEBPACK FOOTER //
// ./src/js/modules/ToggleMainNav.js